export default "__VITE_ASSET__CiUbOu71__"